import React from "react";
import PropTypes from "prop-types";
import Select from "../BaseControls/Select";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";

export default class Dropdown extends React.Component {
    render() {
        const {descriptor} = this.props;
        const {
            options: rawOptions = [],
            valueKey = "value",
            labelKey = "label",
            allowNull,
        } = descriptor.config;
        const options = rawOptions.map(option =>
            typeof option === "string"
                ? { [valueKey]: option, [labelKey]: option }
                : option);

        return (
            <ControlTemplate {...this.props} className="choice-field" >
                <Select
                    {...this.props}
                    options={options}
                    valueKey={valueKey}
                    labelKey={labelKey}
                    addMissing={allowNull}
                />
            </ControlTemplate>
        );
    }
}

Dropdown.propTypes = controlPropTypes({
    allowNull: PropTypes.bool,
    options: PropTypes.array.isRequired,
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/StringField/dropdown.js